/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_HintInputs */



/**
* | output |
* | --- |
* | "Tables fill rooms in order" |
*
* @param {Rooms_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_hint = /** @type {((inputs?: Rooms_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les tables remplissent les salles dans l'ordre")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las mesas llenan las salas en orden")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As mesas preenchem as salas em ordem")
	if (locale === "it") return /** @type {LocalizedString} */ ("I tavoli riempiono le sale in ordine")
	return /** @type {LocalizedString} */ ("Tables fill rooms in order")
});